export const EVENT_FILTER_SCOPE = {
	ALL_ACTIVITY: "all-activity",
	DASHBOARD: "dashboard",
} as const;

export type EventFilterScope =
	(typeof EVENT_FILTER_SCOPE)[keyof typeof EVENT_FILTER_SCOPE];
